import axios from 'axios'
import auth from '../auth'

const api = axios.create({
  baseURL: process.env.VUE_APP_AUTH_URI
})

api.CancelToken = axios.CancelToken
api.isCancel = axios.isCan

api.interceptors.request.use(async (config) => {
  let accessToken = await auth.getToken();
  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`
  }
  return config
})

export default api